<template>
	<div class="index">
	<div class="pre">
		<div class="pre_right">
			<div class="typeList" v-if="device !== 'mobile'">
				选择分类：<br/>
				<a :class="['type', xuanz==index ? 'xuanz' : '']" v-for="(item,index) in typeList" :key="index"  @click="radChange(item.id,index)" >{{ item.name }}</a>
			</div>
			<div v-else class="typeList">
				<el-dropdown trigger="click">
					<span class="el-dropdown-link">
						选择分类
					</span>
                  	<i class="el-icon-arrow-down el-icon--right"></i>
              	<el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="type" v-for="(item,index) in typeList" :key="index"  @click="radChange(item.id)" >{{ item.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
			</div>
			<div class="gdl_r_d1">
				<div @click="selectType(1)" :class="'gdlrd1_d1' + (typeIndex == 1 ? ' gdlrd1_d1_select' : '')">综合</div>
				<div @click="selectType(2)" :class="'gdlrd1_d1' + (typeIndex == 2 ? ' gdlrd1_d1_select' : '')">销量 <img v-show="typeIndex == 2"
					 src="../../assets/imgs/6.png" /><img v-show="typeIndex != 2" src="../../assets/imgs/7.png" /></div>
				<div @click="selectType(3)" :class="'gdlrd1_d1' + (typeIndex == 3 ? ' gdlrd1_d1_select' : '')">价格 <img v-show="typeIndex == 3"
					 src="../../assets/imgs/6.png" /><img v-show="typeIndex != 3" src="../../assets/imgs/7.png" /></div>
				<div class="gdlrd1_d2">共{{ allCount }}件商品</div>
			</div>
			<div class="big">
				<div class="goodsList">
				<div class="good" v-for="(item,index) in goodsList" :key="index" @click="toDetail(item.id)">
					<img class="goodimg" :src="imgUrl + item.Pic" />
					<div class="goodname">{{ item.Name }}</div>
					<div class="txt">{{ item.Name }}</div>
				</div>
				</div>
			</div>
			
			<div class="page">
				<el-pagination class="prerbot_d2_elp" background @current-change="handleCurrentChange"
				 :page-size="pageSize" :layout="device === 'mobile' ? 'prev, pager' : 'total, prev, pager, next, jumper'" :total="allCount">
				</el-pagination>
			</div>
		</div>
	</div>
	</div>
</template>

<script>
import { VUE_APP_IMG_URL } from "@/config"
import { mapGetters, mapMutations } from "vuex"
	export default {
		data() {
			return {
				typeIndex: 1,
				page: 0,
				pageSize: 12,
				radio: "",
				rxlist: [],
				imgUrl: "",
				allCount: "",
				typeId:"",
				goodsList: [],
				typeList:[],
				xuanz:null,
			}
		},
		computed: {
            ...mapGetters(["seachKey","device"])
		},
		watch: {
			seachKey(newval, olval) {
			this.page = 0
			this.GetProductList()
        },
		},
		created: function() {
			this.imgUrl = VUE_APP_IMG_URL
		},
		mounted: function() {
			this.GetProTypeList()
			this.getRXProductList()
			this.GetProductList()
		},
		methods: {
			...mapMutations("goods", ["SET_SEACH_KEY"]),
			selectType(index) {
				if (this.typeIndex != index) {
					this.typeIndex = index
					this.page = 0
					this.GetProductList()
				}
			},
			radChange(e,index){
				this.typeId = e
				this.xuanz=index
				this.page = 0
				this.GetProductList()
			},
			toDetail(id) {
				this.$router.push({
					path: '/goodsDetail',
					query: {
						id: id
					}
				});
			},
			handleCurrentChange(e) {
				this.page = e - 1
				window.scrollTo(0, 0)
				this.GetProductList()

			},
			GetProTypeList() {
				var that = this;
				that.$post('GetProTypeList', {
						"pid": 0
					})
					.then(function(res) {
						that.typeList = res.data.ResultData
					})
			},
			getRXProductList() {
				var that = this;
				that.$post('GetRXProductList', {
						"page": 0
					})
					.then(function(res) {
						that.rxlist = res.data.ResultData
						for (var i in that.rxlist) {
							that.rxlist[i].Pic = that.rxlist[i].Pic.split(",")[0]
						}
					})
			},
			GetProductList() {
				var that = this;
				that.$post('GetProductList', {
						"page": that.page,
						pageSize:that.pageSize,
						orderBy: that.typeIndex,
						TypeId:that.typeId,
						KeyWords: that.seachKey,
					})
					.then(function(res) {
						that.goodsList = res.data.ResultData
						that.allCount = res.data.RowCount
						for (var i in that.goodsList) {
							that.goodsList[i].Pic = that.goodsList[i].Pic.split(",")[0]
						}
					})
			}
		}
	}
</script>

<style scoped>
.index {
  width: 100%;
  background-image: url("../Home/img/组17.png");
  background-size: cover;
  /* 调整背景图片的尺寸，以填充整个容器 */
  background-position: center;
}
.typeList{
	background-color: white;
	padding: 20px;
	margin: 20px auto;
	border: 1px solid #dedede;
}
.type{
	display: inline-block;
	margin-top: 10px;
	margin-right: 10px;
	padding-right: 10px;
	border-right: 1.5px solid black;
}
.type:hover{
	color: red;
}
.big{
	display: flex;
  justify-content: center;
  align-items: center;
}

.goodsList {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  justify-content: center;
}
.good{
	background-color: white;
	margin: 10px;
}
.goodimg{
	width: 250px;
	height: 250px;
	margin: 12px;
}
.goodname{
	text-align: center;
}
.txt{
	text-align: center;
	margin-top: 10px;
}
.page{
	width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 28px;
    margin-bottom: 28px;
}
.xuanz{
	color: red;
}
</style>
<style lang="scss" scoped src="./mobile.scss" ></style>